import React from 'react'
import { useEffect, useState } from 'react'
import Tabs from '../../../../Components/Tabs'
import GetIcon from '../../../../utils/Icon'
import { useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import { useCreateShipmentMutation, useUpdateShipmentMutation, useSubmitShipmentMutation, useGetShipmentByIdQuery } from "../../../../store/api/shipmentApi";
import Button from '../../../../Core/Button/Button'
import printerimg from "../../../../assets/print.png"
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import Table from './Table'
import Attachment from '../../../../utils/Attachment'



function Shipmentform({ shipment_id }) {
    const [createShipment, { data, isLoading, errors }] = useCreateShipmentMutation();
    const [updateShipment, { data: updatedData, isLoading: isUpdating, error: updateError }] = useUpdateShipmentMutation();
    const [submitShipment, { isLoading: isSubmitting, error: submitError, data: submitData }] = useSubmitShipmentMutation();
    const { data: shipmentDetail, isLoading: isLoadingnew } = useGetShipmentByIdQuery(shipment_id);


    const [TableData, setTableData] = useState([]);
    const [selectedDeliveryNotes, setSelectedDeliveryNotes] = useState([]);
    const [deliveryNoteList, setDeliveryNoteList] = useState([]);
    const [salesinvoiceList, setsalesinvoiceList] = useState([]);
    const [selectedSalesInvoices, setSelectedSalesInvoices] = useState([]);
    const [status, setstatus] = useState("");
    const [formattedDeliveryNotes, setformattedDeliveryNotes] = useState([]);
    const [formattedSalesInvoiceOptions, setformattedSalesInvoiceOptions] = useState([]);
    const [fields, setFields] = useState({})
    const nvg = useNavigate()
    const [item, setItem] = useState(false)
    const [buttonData, setButtonData] = useState(false)
    const [tab, settab] = useState(1)
    const [ptype, setptype] = useState("Error ")
    const [showpopup, setShowpopup] = useState(false);
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState('');
    const [fieldErrors, setFieldErrors] = useState({
        customer: false,
        dueDate: false,
        billing_address: false,
        shipping_address: false,
        billingType: false,
        order_type: false,
        items: false
    });
    const [po_response, setpo_response] = useState("");
    const [selectedDocTypes, setSelectedDocTypes] = useState([]);
    const [tab1Data, setTab1Data] = useState({});
    const [shipemntno, setshipemntno] = useState('');
    useEffect(() => {
        if (shipmentDetail?.data) {
            const response = shipmentDetail.data;
            setFields({
                shipment: response.name,
                pickupDate: response.pickup_date,
                handoverTime: response.custom_handover_time?.length === 5
                    ? `${response.custom_handover_time}:00`
                    : response.custom_handover_time,
                logistics_provider: response.custom_logistics_provider,
                driver_mobile_number: response.custom_driver_mobile_number,
                driverLicense: response.custom_driver_license_number,
                drivername: response.custom_driver_name,
                description: response.description_of_content,
                date: response.creation.slice(0, 10)
            });

            console.log(response.doctype, "response.doctype");
            setstatus(shipmentDetail?.data?.status)
            const docTypes = [];
            if (response.shipment_delivery_note?.length > 0) {
                docTypes.push('DeliveryNote');
            }
            if (response.custom_shipment_sales_invoice?.length > 0) {
                docTypes.push('Sales Invoice');
            }
            setSelectedDocTypes(docTypes);
            const deliveryNotes = response.shipment_delivery_note?.map(note => note.delivery_note) || [];
            setSelectedDeliveryNotes(deliveryNotes);

            const formattedDeliveryNotes = response.shipment_delivery_note.map(note => ({
                value: note.delivery_note,
                label: note.delivery_note,
                labeltwo: note.grand_total
            }));
            setformattedDeliveryNotes(formattedDeliveryNotes)

            const salesinvoice = response.custom_shipment_sales_invoice?.map(note => note.sales_invoice) || [];
            setSelectedSalesInvoices(salesinvoice);
            const formattedSalesInvoiceOptions = response.custom_shipment_sales_invoice.map(note => ({
                value: note.sales_invoice,
                label: note.sales_invoice,
                labeltwo: note.value
            }));
            setformattedSalesInvoiceOptions(formattedSalesInvoiceOptions)

            const packingSlips = response.custom_packing_slips_?.map(slip => ({
                name: slip.box_id,
                delivery_note: slip.delivery_note,
                sales_invoice: slip.sales_invoice || "",
                gross_weight_pkg: parseFloat(slip.box_weight) || 0,
                is_verified: slip.is_verified === 1
            })) || [];
            setTableData(packingSlips);

            setshipemntno(response.name);
            setItem(true);
        }
    }, [shipmentDetail]);


    

    const [activityboll, setactivityboll] = useState(false)



const calculatedTotal = shipmentDetail?.data?.status === 'Submitted'
    ? shipmentDetail?.data?.value_of_goods
    : (
        deliveryNoteList
            .filter(note => selectedDeliveryNotes.includes(note.name))
            .reduce((sum, note) => sum + (note.grand_total || 0), 0) +
        salesinvoiceList
            .filter(inv => selectedSalesInvoices.includes(inv.name))
            .reduce((sum, inv) => sum + (inv.grand_total || 0), 0)
    );



    const verifiedCount = TableData.filter(item => item.is_verified).length;


    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between " style={{ background: "#fcfdfe", height: '40px', padding: '0px 5px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0 "> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/shippinglist')}>Shipment List  </p>
                    <p className="m-0 ">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79", fontSize: '' }} >
                        View Shipment
                        <button
                            className={` ${buttonData
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {shipmentDetail?.data?.status}
                        </button>
                    </a>
                </div>



            </div>
            <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>


                        </ul>
                          <Attachment doctype="Shipment"  docname={shipment_id}  /> 
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px', flexGrow: '1' }}>
                    {/* className="row sidebarbox m-0" style={{ padding: "8px", borderRadius: "5px",  height: "70vh",overflowY: "scroll"}} */}
                    <div className="col-3 sidebarbox" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', overflow: tab == 1 ? "" : 'hidden' }}>
                        <Tab1 formattedSalesInvoiceOptions={formattedSalesInvoiceOptions} formattedDeliveryNotes={formattedDeliveryNotes} status={status} fields={fields} setFields={setFields} selectedDeliveryNotes={selectedDeliveryNotes} setSelectedDeliveryNotes={setSelectedDeliveryNotes} setDeliveryNoteList={setDeliveryNoteList} setsalesinvoiceList={setsalesinvoiceList} setTab1Data={setTab1Data} setTableData={setTableData} fieldErrors={fieldErrors} activityboll={activityboll} shipemntno={shipemntno} setSelectedDocTypes={setSelectedDocTypes} selectedDocTypes={selectedDocTypes} setSelectedSalesInvoices={setSelectedSalesInvoices} selectedSalesInvoices={selectedSalesInvoices}

                        />
                    </div>
                    {tab == 1 ? <div className="col-9 d-flex flex-column mt-2" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>
                        <div className="d-flex justify-content-between align-items-center pb-2" style={{ gap: '5px' }}>

                            {/* <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', overflow: tab == 1 ? "" : 'hidden' }}> */}
                            <div className="d-flex pb-2" style={{ gap: '5px' }}>
                                <p className="NoOfLine">No. of Lines - <span style={{ color: '#2563EB' }}> {TableData.length}</span></p>
                                <p className="NoOfLine">No.of SalesInvoices - <span style={{ color: '#2563EB' }}> {selectedSalesInvoices.length}</span></p>

                                <p className="NoOfLine">No. of DeliveryNotes - <span style={{ color: '#2563EB' }}> {selectedDeliveryNotes.length}</span></p>
                                <p className="TotalQty">Value of Goods -  <span style={{ color: '#16A34A' }}> {calculatedTotal}</span></p>
                                <p className="TotalQty">Scanned Boxes -  <span style={{ color: '#16A34A' }}> {verifiedCount}</span></p>


                            </div>
                          

                        </div>
                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', fontSize: '15px', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table
                            TableData={TableData}


                        />
                        {/* <div className=" mt-auto pb-1" style={{ display: po_response.data ? '' : 'none' }}>

                            <div className="row">
                                <div className="col-3">
                                    <p className="TotalQtywithoutBg">Ordered Quantity -  <span className="px-2" style={{ color: '#EC642A' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Taxable Value - <span className="px-2" style={{ color: '#FF5969' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Tax - <span className="px-2" style={{ color: '#2563EB' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Total Value - <span className="px-2" style={{ color: '#16A34A' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)}</span></p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                        : ''}

                </div>
            </div>

            <ApiResponseBox
                poptype={ptype}
                show={showError}
                errorMessage={error}
                onClose={() => setShowError(false)}
            />


        </>
    )
}

export default Shipmentform
